"use strict";
// DO NOT EDIT. Generated by gitlab.com/accumulatenetwork/accumulate/tools/cmd/gen-types.
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteType = exports.TransactionType = exports.TransactionMax = exports.SignatureType = exports.PartitionType = exports.ObjectType = exports.NetworkMaintenanceOperationType = exports.KeyPageOperationType = exports.ExecutorVersion = exports.DataEntryType = exports.BookType = exports.AllowedTransactionBit = exports.AccountType = exports.AccountAuthOperationType = void 0;
/* eslint-disable @typescript-eslint/no-namespace */
var AccountAuthOperationType;
(function (AccountAuthOperationType) {
    /** Unknown is used when the authorization operation is not known. */
    AccountAuthOperationType[AccountAuthOperationType["Unknown"] = 0] = "Unknown";
    /** Enable enables authorization checks for an authority. */
    AccountAuthOperationType[AccountAuthOperationType["Enable"] = 1] = "Enable";
    /** Disable disables authorization checks for an authority. */
    AccountAuthOperationType[AccountAuthOperationType["Disable"] = 2] = "Disable";
    /** AddAuthority adds an authority. */
    AccountAuthOperationType[AccountAuthOperationType["AddAuthority"] = 3] = "AddAuthority";
    /** RemoveAuthority removes an authority. */
    AccountAuthOperationType[AccountAuthOperationType["RemoveAuthority"] = 4] = "RemoveAuthority";
})(AccountAuthOperationType = exports.AccountAuthOperationType || (exports.AccountAuthOperationType = {}));
/** @ignore */
(function (AccountAuthOperationType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    AccountAuthOperationType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "unknown":
                return AccountAuthOperationType.Unknown;
            case "enable":
                return AccountAuthOperationType.Enable;
            case "disable":
                return AccountAuthOperationType.Disable;
            case "addauthority":
                return AccountAuthOperationType.AddAuthority;
            case "removeauthority":
                return AccountAuthOperationType.RemoveAuthority;
            default:
                throw new Error(`Unknown AccountAuthOperationType '${name}'`);
        }
    }
    AccountAuthOperationType.byName = byName;
    function getName(v) {
        switch (v) {
            case AccountAuthOperationType.Unknown:
                return "unknown";
            case AccountAuthOperationType.Enable:
                return "enable";
            case AccountAuthOperationType.Disable:
                return "disable";
            case AccountAuthOperationType.AddAuthority:
                return "addAuthority";
            case AccountAuthOperationType.RemoveAuthority:
                return "removeAuthority";
            default:
                throw new Error(`Unknown AccountAuthOperationType ${v}`);
        }
    }
    AccountAuthOperationType.getName = getName;
})(AccountAuthOperationType = exports.AccountAuthOperationType || (exports.AccountAuthOperationType = {}));
var AccountType;
(function (AccountType) {
    /** Unknown represents an unknown account type. */
    AccountType[AccountType["Unknown"] = 0] = "Unknown";
    /** AnchorLedger anchors the other partitions. */
    AccountType[AccountType["AnchorLedger"] = 1] = "AnchorLedger";
    /** Identity is an Identity account, aka an ADI. */
    AccountType[AccountType["Identity"] = 2] = "Identity";
    /** TokenIssuer is a Token Issuer account. */
    AccountType[AccountType["TokenIssuer"] = 3] = "TokenIssuer";
    /** TokenAccount is an ADI Token Account. */
    AccountType[AccountType["TokenAccount"] = 4] = "TokenAccount";
    /** LiteTokenAccount is a Lite Token Account. */
    AccountType[AccountType["LiteTokenAccount"] = 5] = "LiteTokenAccount";
    /** BlockLedger is a Block Ledger account. */
    AccountType[AccountType["BlockLedger"] = 6] = "BlockLedger";
    /** KeyPage is a Key Page account. */
    AccountType[AccountType["KeyPage"] = 9] = "KeyPage";
    /** KeyBook is a Key Book account. */
    AccountType[AccountType["KeyBook"] = 10] = "KeyBook";
    /** DataAccount is an ADI Data Account. */
    AccountType[AccountType["DataAccount"] = 11] = "DataAccount";
    /** LiteDataAccount is a Lite Data Account. */
    AccountType[AccountType["LiteDataAccount"] = 12] = "LiteDataAccount";
    /** UnknownSigner represents an unknown signer account. */
    AccountType[AccountType["UnknownSigner"] = 13] = "UnknownSigner";
    /** SystemLedger is a ledger that tracks the state of internal operations. */
    AccountType[AccountType["SystemLedger"] = 14] = "SystemLedger";
    /** LiteIdentity is a lite identity account. */
    AccountType[AccountType["LiteIdentity"] = 15] = "LiteIdentity";
    /** SyntheticLedger is a ledger that tracks the status of produced and received synthetic transactions. */
    AccountType[AccountType["SyntheticLedger"] = 16] = "SyntheticLedger";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
/** @ignore */
(function (AccountType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    AccountType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "unknown":
                return AccountType.Unknown;
            case "anchorledger":
                return AccountType.AnchorLedger;
            case "identity":
                return AccountType.Identity;
            case "tokenissuer":
                return AccountType.TokenIssuer;
            case "token":
                return AccountType.TokenIssuer;
            case "tokenaccount":
                return AccountType.TokenAccount;
            case "litetokenaccount":
                return AccountType.LiteTokenAccount;
            case "blockledger":
                return AccountType.BlockLedger;
            case "keypage":
                return AccountType.KeyPage;
            case "keybook":
                return AccountType.KeyBook;
            case "dataaccount":
                return AccountType.DataAccount;
            case "litedataaccount":
                return AccountType.LiteDataAccount;
            case "unknownsigner":
                return AccountType.UnknownSigner;
            case "systemledger":
                return AccountType.SystemLedger;
            case "liteidentity":
                return AccountType.LiteIdentity;
            case "syntheticledger":
                return AccountType.SyntheticLedger;
            default:
                throw new Error(`Unknown AccountType '${name}'`);
        }
    }
    AccountType.byName = byName;
    function getName(v) {
        switch (v) {
            case AccountType.Unknown:
                return "unknown";
            case AccountType.AnchorLedger:
                return "anchorLedger";
            case AccountType.Identity:
                return "identity";
            case AccountType.TokenIssuer:
                return "tokenIssuer";
            case AccountType.TokenAccount:
                return "tokenAccount";
            case AccountType.LiteTokenAccount:
                return "liteTokenAccount";
            case AccountType.BlockLedger:
                return "blockLedger";
            case AccountType.KeyPage:
                return "keyPage";
            case AccountType.KeyBook:
                return "keyBook";
            case AccountType.DataAccount:
                return "dataAccount";
            case AccountType.LiteDataAccount:
                return "liteDataAccount";
            case AccountType.UnknownSigner:
                return "unknownSigner";
            case AccountType.SystemLedger:
                return "systemLedger";
            case AccountType.LiteIdentity:
                return "liteIdentity";
            case AccountType.SyntheticLedger:
                return "syntheticLedger";
            default:
                throw new Error(`Unknown AccountType ${v}`);
        }
    }
    AccountType.getName = getName;
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var AllowedTransactionBit;
(function (AllowedTransactionBit) {
    /** UpdateKeyPage is the offset of the UpdateKeyPage bit. */
    AllowedTransactionBit[AllowedTransactionBit["UpdateKeyPage"] = 1] = "UpdateKeyPage";
    /** UpdateAccountAuth is the offset of the UpdateAccountAuth bit. */
    AllowedTransactionBit[AllowedTransactionBit["UpdateAccountAuth"] = 2] = "UpdateAccountAuth";
})(AllowedTransactionBit = exports.AllowedTransactionBit || (exports.AllowedTransactionBit = {}));
/** @ignore */
(function (AllowedTransactionBit) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    AllowedTransactionBit.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "updatekeypage":
                return AllowedTransactionBit.UpdateKeyPage;
            case "updateaccountauth":
                return AllowedTransactionBit.UpdateAccountAuth;
            default:
                throw new Error(`Unknown AllowedTransactionBit '${name}'`);
        }
    }
    AllowedTransactionBit.byName = byName;
    function getName(v) {
        switch (v) {
            case AllowedTransactionBit.UpdateKeyPage:
                return "updateKeyPage";
            case AllowedTransactionBit.UpdateAccountAuth:
                return "updateAccountAuth";
            default:
                throw new Error(`Unknown AllowedTransactionBit ${v}`);
        }
    }
    AllowedTransactionBit.getName = getName;
})(AllowedTransactionBit = exports.AllowedTransactionBit || (exports.AllowedTransactionBit = {}));
var BookType;
(function (BookType) {
    /** Normal is a normal key book. */
    BookType[BookType["Normal"] = 0] = "Normal";
    /** Validator is a validator key book. */
    BookType[BookType["Validator"] = 1] = "Validator";
    /** Operator Operator key book. */
    BookType[BookType["Operator"] = 2] = "Operator";
})(BookType = exports.BookType || (exports.BookType = {}));
/** @ignore */
(function (BookType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    BookType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "normal":
                return BookType.Normal;
            case "validator":
                return BookType.Validator;
            case "operator":
                return BookType.Operator;
            default:
                throw new Error(`Unknown BookType '${name}'`);
        }
    }
    BookType.byName = byName;
    function getName(v) {
        switch (v) {
            case BookType.Normal:
                return "normal";
            case BookType.Validator:
                return "validator";
            case BookType.Operator:
                return "operator";
            default:
                throw new Error(`Unknown BookType ${v}`);
        }
    }
    BookType.getName = getName;
})(BookType = exports.BookType || (exports.BookType = {}));
var DataEntryType;
(function (DataEntryType) {
    /** Unknown . */
    DataEntryType[DataEntryType["Unknown"] = 0] = "Unknown";
    /** Factom . */
    DataEntryType[DataEntryType["Factom"] = 1] = "Factom";
    /** Accumulate . */
    DataEntryType[DataEntryType["Accumulate"] = 2] = "Accumulate";
    /** DoubleHash . */
    DataEntryType[DataEntryType["DoubleHash"] = 3] = "DoubleHash";
})(DataEntryType = exports.DataEntryType || (exports.DataEntryType = {}));
/** @ignore */
(function (DataEntryType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    DataEntryType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "unknown":
                return DataEntryType.Unknown;
            case "factom":
                return DataEntryType.Factom;
            case "accumulate":
                return DataEntryType.Accumulate;
            case "doublehash":
                return DataEntryType.DoubleHash;
            default:
                throw new Error(`Unknown DataEntryType '${name}'`);
        }
    }
    DataEntryType.byName = byName;
    function getName(v) {
        switch (v) {
            case DataEntryType.Unknown:
                return "unknown";
            case DataEntryType.Factom:
                return "factom";
            case DataEntryType.Accumulate:
                return "accumulate";
            case DataEntryType.DoubleHash:
                return "doubleHash";
            default:
                throw new Error(`Unknown DataEntryType ${v}`);
        }
    }
    DataEntryType.getName = getName;
})(DataEntryType = exports.DataEntryType || (exports.DataEntryType = {}));
var ExecutorVersion;
(function (ExecutorVersion) {
    /** V1 is the first version of the executor system. */
    ExecutorVersion[ExecutorVersion["V1"] = 1] = "V1";
    /** V1SignatureAnchoring introduces anchoring of signature chains into the root chain. */
    ExecutorVersion[ExecutorVersion["V1SignatureAnchoring"] = 2] = "V1SignatureAnchoring";
    /** V1DoubleHashEntries fixes a problem that prevented v1-signatureAnchoring from being activated correctly and enables double-hashed data entries. */
    ExecutorVersion[ExecutorVersion["V1DoubleHashEntries"] = 3] = "V1DoubleHashEntries";
    /** V1Halt halts transaction processing in preparation for v2. */
    ExecutorVersion[ExecutorVersion["V1Halt"] = 4] = "V1Halt";
    /** V2 is the second version of the executor system. */
    ExecutorVersion[ExecutorVersion["V2"] = 5] = "V2";
    /** V2Baikonur enables the Baikonur release. */
    ExecutorVersion[ExecutorVersion["V2Baikonur"] = 6] = "V2Baikonur";
    /** V2Vandenberg enables the Vandenberg release. */
    ExecutorVersion[ExecutorVersion["V2Vandenberg"] = 7] = "V2Vandenberg";
    /** VNext is a placeholder for testing. DO NOT USE. */
    ExecutorVersion[ExecutorVersion["VNext"] = 8] = "VNext";
})(ExecutorVersion = exports.ExecutorVersion || (exports.ExecutorVersion = {}));
/** @ignore */
(function (ExecutorVersion) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    ExecutorVersion.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "v1":
                return ExecutorVersion.V1;
            case "v1-signatureanchoring":
                return ExecutorVersion.V1SignatureAnchoring;
            case "v1-doublehashentries":
                return ExecutorVersion.V1DoubleHashEntries;
            case "v1-halt":
                return ExecutorVersion.V1Halt;
            case "v2":
                return ExecutorVersion.V2;
            case "v2baikonur":
                return ExecutorVersion.V2Baikonur;
            case "v2-baikonur":
                return ExecutorVersion.V2Baikonur;
            case "v2-vandenberg":
                return ExecutorVersion.V2Vandenberg;
            case "vnext":
                return ExecutorVersion.VNext;
            default:
                throw new Error(`Unknown ExecutorVersion '${name}'`);
        }
    }
    ExecutorVersion.byName = byName;
    function getName(v) {
        switch (v) {
            case ExecutorVersion.V1:
                return "v1";
            case ExecutorVersion.V1SignatureAnchoring:
                return "v1-signatureAnchoring";
            case ExecutorVersion.V1DoubleHashEntries:
                return "v1-doubleHashEntries";
            case ExecutorVersion.V1Halt:
                return "v1-halt";
            case ExecutorVersion.V2:
                return "v2";
            case ExecutorVersion.V2Baikonur:
                return "v2Baikonur";
            case ExecutorVersion.V2Vandenberg:
                return "v2-vandenberg";
            case ExecutorVersion.VNext:
                return "vnext";
            default:
                throw new Error(`Unknown ExecutorVersion ${v}`);
        }
    }
    ExecutorVersion.getName = getName;
})(ExecutorVersion = exports.ExecutorVersion || (exports.ExecutorVersion = {}));
var KeyPageOperationType;
(function (KeyPageOperationType) {
    /** Unknown is used when the key page operation is not known. */
    KeyPageOperationType[KeyPageOperationType["Unknown"] = 0] = "Unknown";
    /** Update replaces a key in the page with a new key. */
    KeyPageOperationType[KeyPageOperationType["Update"] = 1] = "Update";
    /** Remove removes a key from the page. */
    KeyPageOperationType[KeyPageOperationType["Remove"] = 2] = "Remove";
    /** Add adds a key to the page. */
    KeyPageOperationType[KeyPageOperationType["Add"] = 3] = "Add";
    /** SetThreshold sets the signing threshold (the M of "M of N" signatures required). */
    KeyPageOperationType[KeyPageOperationType["SetThreshold"] = 4] = "SetThreshold";
    /** UpdateAllowed updates the transactions the key page is allowed to execute. */
    KeyPageOperationType[KeyPageOperationType["UpdateAllowed"] = 5] = "UpdateAllowed";
    /** SetRejectThreshold sets the rejection threshold. */
    KeyPageOperationType[KeyPageOperationType["SetRejectThreshold"] = 6] = "SetRejectThreshold";
    /** SetResponseThreshold sets the response threshold. */
    KeyPageOperationType[KeyPageOperationType["SetResponseThreshold"] = 7] = "SetResponseThreshold";
})(KeyPageOperationType = exports.KeyPageOperationType || (exports.KeyPageOperationType = {}));
/** @ignore */
(function (KeyPageOperationType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    KeyPageOperationType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "unknown":
                return KeyPageOperationType.Unknown;
            case "update":
                return KeyPageOperationType.Update;
            case "remove":
                return KeyPageOperationType.Remove;
            case "add":
                return KeyPageOperationType.Add;
            case "setthreshold":
                return KeyPageOperationType.SetThreshold;
            case "updateallowed":
                return KeyPageOperationType.UpdateAllowed;
            case "setrejectthreshold":
                return KeyPageOperationType.SetRejectThreshold;
            case "setresponsethreshold":
                return KeyPageOperationType.SetResponseThreshold;
            default:
                throw new Error(`Unknown KeyPageOperationType '${name}'`);
        }
    }
    KeyPageOperationType.byName = byName;
    function getName(v) {
        switch (v) {
            case KeyPageOperationType.Unknown:
                return "unknown";
            case KeyPageOperationType.Update:
                return "update";
            case KeyPageOperationType.Remove:
                return "remove";
            case KeyPageOperationType.Add:
                return "add";
            case KeyPageOperationType.SetThreshold:
                return "setThreshold";
            case KeyPageOperationType.UpdateAllowed:
                return "updateAllowed";
            case KeyPageOperationType.SetRejectThreshold:
                return "setRejectThreshold";
            case KeyPageOperationType.SetResponseThreshold:
                return "setResponseThreshold";
            default:
                throw new Error(`Unknown KeyPageOperationType ${v}`);
        }
    }
    KeyPageOperationType.getName = getName;
})(KeyPageOperationType = exports.KeyPageOperationType || (exports.KeyPageOperationType = {}));
var NetworkMaintenanceOperationType;
(function (NetworkMaintenanceOperationType) {
    /** Unknown is used when the operation type is not known. */
    NetworkMaintenanceOperationType[NetworkMaintenanceOperationType["Unknown"] = 0] = "Unknown";
    /** PendingTransactionGC removes pending transaction garbage. */
    NetworkMaintenanceOperationType[NetworkMaintenanceOperationType["PendingTransactionGC"] = 1] = "PendingTransactionGC";
})(NetworkMaintenanceOperationType = exports.NetworkMaintenanceOperationType || (exports.NetworkMaintenanceOperationType = {}));
/** @ignore */
(function (NetworkMaintenanceOperationType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    NetworkMaintenanceOperationType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "unknown":
                return NetworkMaintenanceOperationType.Unknown;
            case "pendingtransactiongc":
                return NetworkMaintenanceOperationType.PendingTransactionGC;
            default:
                throw new Error(`Unknown NetworkMaintenanceOperationType '${name}'`);
        }
    }
    NetworkMaintenanceOperationType.byName = byName;
    function getName(v) {
        switch (v) {
            case NetworkMaintenanceOperationType.Unknown:
                return "unknown";
            case NetworkMaintenanceOperationType.PendingTransactionGC:
                return "pendingTransactionGC";
            default:
                throw new Error(`Unknown NetworkMaintenanceOperationType ${v}`);
        }
    }
    NetworkMaintenanceOperationType.getName = getName;
})(NetworkMaintenanceOperationType = exports.NetworkMaintenanceOperationType || (exports.NetworkMaintenanceOperationType = {}));
var ObjectType;
(function (ObjectType) {
    /** Unknown is used when the object type is not known. */
    ObjectType[ObjectType["Unknown"] = 0] = "Unknown";
    /** Account represents an account object. */
    ObjectType[ObjectType["Account"] = 1] = "Account";
    /** Transaction represents a transaction object. */
    ObjectType[ObjectType["Transaction"] = 2] = "Transaction";
})(ObjectType = exports.ObjectType || (exports.ObjectType = {}));
/** @ignore */
(function (ObjectType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    ObjectType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "unknown":
                return ObjectType.Unknown;
            case "account":
                return ObjectType.Account;
            case "transaction":
                return ObjectType.Transaction;
            default:
                throw new Error(`Unknown ObjectType '${name}'`);
        }
    }
    ObjectType.byName = byName;
    function getName(v) {
        switch (v) {
            case ObjectType.Unknown:
                return "unknown";
            case ObjectType.Account:
                return "account";
            case ObjectType.Transaction:
                return "transaction";
            default:
                throw new Error(`Unknown ObjectType ${v}`);
        }
    }
    ObjectType.getName = getName;
})(ObjectType = exports.ObjectType || (exports.ObjectType = {}));
var PartitionType;
(function (PartitionType) {
    /** Directory . */
    PartitionType[PartitionType["Directory"] = 1] = "Directory";
    /** BlockValidator . */
    PartitionType[PartitionType["BlockValidator"] = 2] = "BlockValidator";
    /** BlockSummary . */
    PartitionType[PartitionType["BlockSummary"] = 3] = "BlockSummary";
    /** Bootstrap . */
    PartitionType[PartitionType["Bootstrap"] = 4] = "Bootstrap";
})(PartitionType = exports.PartitionType || (exports.PartitionType = {}));
/** @ignore */
(function (PartitionType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    PartitionType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "directory":
                return PartitionType.Directory;
            case "blockvalidator":
                return PartitionType.BlockValidator;
            case "block-validator":
                return PartitionType.BlockValidator;
            case "blocksummary":
                return PartitionType.BlockSummary;
            case "block-summary":
                return PartitionType.BlockSummary;
            case "bootstrap":
                return PartitionType.Bootstrap;
            default:
                throw new Error(`Unknown PartitionType '${name}'`);
        }
    }
    PartitionType.byName = byName;
    function getName(v) {
        switch (v) {
            case PartitionType.Directory:
                return "directory";
            case PartitionType.BlockValidator:
                return "blockValidator";
            case PartitionType.BlockSummary:
                return "blockSummary";
            case PartitionType.Bootstrap:
                return "bootstrap";
            default:
                throw new Error(`Unknown PartitionType ${v}`);
        }
    }
    PartitionType.getName = getName;
})(PartitionType = exports.PartitionType || (exports.PartitionType = {}));
var SignatureType;
(function (SignatureType) {
    /** Unknown is used when the signature type is not known. */
    SignatureType[SignatureType["Unknown"] = 0] = "Unknown";
    /** LegacyED25519 represents a legacy ED25519 signature. */
    SignatureType[SignatureType["LegacyED25519"] = 1] = "LegacyED25519";
    /** ED25519 represents an ED25519 signature. */
    SignatureType[SignatureType["ED25519"] = 2] = "ED25519";
    /** RCD1 represents an RCD1 signature. */
    SignatureType[SignatureType["RCD1"] = 3] = "RCD1";
    /** Receipt represents a Merkle tree receipt. */
    SignatureType[SignatureType["Receipt"] = 4] = "Receipt";
    /** Partition is used when sending synthetic and system transactions. */
    SignatureType[SignatureType["Partition"] = 5] = "Partition";
    /** Set is used when forwarding multiple signatures. */
    SignatureType[SignatureType["Set"] = 6] = "Set";
    /** Remote is used when forwarding a signature from one partition to another. */
    SignatureType[SignatureType["Remote"] = 7] = "Remote";
    /** BTC represents an BTC signature. */
    SignatureType[SignatureType["BTC"] = 8] = "BTC";
    /** BTCLegacy represents an BTC signature with uncompressed public key. */
    SignatureType[SignatureType["BTCLegacy"] = 9] = "BTCLegacy";
    /** ETH represents an ETH signature. */
    SignatureType[SignatureType["ETH"] = 10] = "ETH";
    /** Delegated represents a signature for a delegated authority. */
    SignatureType[SignatureType["Delegated"] = 11] = "Delegated";
    /** Internal is used for internally produced transactions. */
    SignatureType[SignatureType["Internal"] = 12] = "Internal";
    /** Authority is a signature produced by an authority. */
    SignatureType[SignatureType["Authority"] = 13] = "Authority";
    /** RsaSha256 represents an RSA signature of SHA256 hashed data (PKCS#1 encoding). */
    SignatureType[SignatureType["RsaSha256"] = 14] = "RsaSha256";
    /** EcdsaSha256 represents a signature of SHA256 hashed data from an ecdsa algorithm with supported standard curves from NIST, SECG, and Brainpool typically (SEC, ANS.1 enocding). */
    SignatureType[SignatureType["EcdsaSha256"] = 15] = "EcdsaSha256";
    /** TypedData implements EIP-712 sign typed data specification. */
    SignatureType[SignatureType["TypedData"] = 16] = "TypedData";
})(SignatureType = exports.SignatureType || (exports.SignatureType = {}));
/** @ignore */
(function (SignatureType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    SignatureType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "unknown":
                return SignatureType.Unknown;
            case "legacyed25519":
                return SignatureType.LegacyED25519;
            case "ed25519":
                return SignatureType.ED25519;
            case "rcd1":
                return SignatureType.RCD1;
            case "receipt":
                return SignatureType.Receipt;
            case "partition":
                return SignatureType.Partition;
            case "synthetic":
                return SignatureType.Partition;
            case "set":
                return SignatureType.Set;
            case "remote":
                return SignatureType.Remote;
            case "btc":
                return SignatureType.BTC;
            case "btclegacy":
                return SignatureType.BTCLegacy;
            case "eth":
                return SignatureType.ETH;
            case "delegated":
                return SignatureType.Delegated;
            case "internal":
                return SignatureType.Internal;
            case "authority":
                return SignatureType.Authority;
            case "rsasha256":
                return SignatureType.RsaSha256;
            case "ecdsasha256":
                return SignatureType.EcdsaSha256;
            case "typeddata":
                return SignatureType.TypedData;
            default:
                throw new Error(`Unknown SignatureType '${name}'`);
        }
    }
    SignatureType.byName = byName;
    function getName(v) {
        switch (v) {
            case SignatureType.Unknown:
                return "unknown";
            case SignatureType.LegacyED25519:
                return "legacyED25519";
            case SignatureType.ED25519:
                return "ed25519";
            case SignatureType.RCD1:
                return "rcd1";
            case SignatureType.Receipt:
                return "receipt";
            case SignatureType.Partition:
                return "partition";
            case SignatureType.Set:
                return "set";
            case SignatureType.Remote:
                return "remote";
            case SignatureType.BTC:
                return "btc";
            case SignatureType.BTCLegacy:
                return "btclegacy";
            case SignatureType.ETH:
                return "eth";
            case SignatureType.Delegated:
                return "delegated";
            case SignatureType.Internal:
                return "internal";
            case SignatureType.Authority:
                return "authority";
            case SignatureType.RsaSha256:
                return "rsaSha256";
            case SignatureType.EcdsaSha256:
                return "ecdsaSha256";
            case SignatureType.TypedData:
                return "typedData";
            default:
                throw new Error(`Unknown SignatureType ${v}`);
        }
    }
    SignatureType.getName = getName;
})(SignatureType = exports.SignatureType || (exports.SignatureType = {}));
var TransactionMax;
(function (TransactionMax) {
    /** User is the highest number reserved for user transactions. */
    TransactionMax[TransactionMax["User"] = 48] = "User";
    /** Synthetic is the highest number reserved for synthetic transactions. */
    TransactionMax[TransactionMax["Synthetic"] = 95] = "Synthetic";
    /** System is the highest number reserved for internal transactions. */
    TransactionMax[TransactionMax["System"] = 255] = "System";
})(TransactionMax = exports.TransactionMax || (exports.TransactionMax = {}));
/** @ignore */
(function (TransactionMax) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    TransactionMax.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "user":
                return TransactionMax.User;
            case "synthetic":
                return TransactionMax.Synthetic;
            case "system":
                return TransactionMax.System;
            default:
                throw new Error(`Unknown TransactionMax '${name}'`);
        }
    }
    TransactionMax.byName = byName;
    function getName(v) {
        switch (v) {
            case TransactionMax.User:
                return "user";
            case TransactionMax.Synthetic:
                return "synthetic";
            case TransactionMax.System:
                return "system";
            default:
                throw new Error(`Unknown TransactionMax ${v}`);
        }
    }
    TransactionMax.getName = getName;
})(TransactionMax = exports.TransactionMax || (exports.TransactionMax = {}));
var TransactionType;
(function (TransactionType) {
    /** Unknown represents an unknown transaction type. */
    TransactionType[TransactionType["Unknown"] = 0] = "Unknown";
    /** CreateIdentity creates an ADI, which produces a synthetic chain. */
    TransactionType[TransactionType["CreateIdentity"] = 1] = "CreateIdentity";
    /** CreateTokenAccount creates an ADI token account, which produces a synthetic chain create transaction. */
    TransactionType[TransactionType["CreateTokenAccount"] = 2] = "CreateTokenAccount";
    /** SendTokens transfers tokens between token accounts, which produces a synthetic deposit tokens transaction. */
    TransactionType[TransactionType["SendTokens"] = 3] = "SendTokens";
    /** CreateDataAccount creates an ADI Data Account, which produces a synthetic chain create transaction. */
    TransactionType[TransactionType["CreateDataAccount"] = 4] = "CreateDataAccount";
    /** WriteData writes data to an ADI Data Account, which *does not* produce a synthetic transaction. */
    TransactionType[TransactionType["WriteData"] = 5] = "WriteData";
    /** WriteDataTo writes data to a Lite Data Account, which produces a synthetic write data transaction. */
    TransactionType[TransactionType["WriteDataTo"] = 6] = "WriteDataTo";
    /** AcmeFaucet produces a synthetic deposit tokens transaction that deposits ACME tokens into a lite token account. */
    TransactionType[TransactionType["AcmeFaucet"] = 7] = "AcmeFaucet";
    /** CreateToken creates a token issuer, which produces a synthetic chain create transaction. */
    TransactionType[TransactionType["CreateToken"] = 8] = "CreateToken";
    /** IssueTokens issues tokens to a token account, which produces a synthetic token deposit transaction. */
    TransactionType[TransactionType["IssueTokens"] = 9] = "IssueTokens";
    /** BurnTokens burns tokens from a token account, which produces a synthetic burn tokens transaction. */
    TransactionType[TransactionType["BurnTokens"] = 10] = "BurnTokens";
    /** CreateLiteTokenAccount create a lite token account. */
    TransactionType[TransactionType["CreateLiteTokenAccount"] = 11] = "CreateLiteTokenAccount";
    /** CreateKeyPage creates a key page, which produces a synthetic chain create transaction. */
    TransactionType[TransactionType["CreateKeyPage"] = 12] = "CreateKeyPage";
    /** CreateKeyBook creates a key book, which produces a synthetic chain create transaction. */
    TransactionType[TransactionType["CreateKeyBook"] = 13] = "CreateKeyBook";
    /** AddCredits converts ACME tokens to credits, which produces a synthetic deposit credits transaction. */
    TransactionType[TransactionType["AddCredits"] = 14] = "AddCredits";
    /** UpdateKeyPage adds, removes, or updates keys in a key page, which *does not* produce a synthetic transaction. */
    TransactionType[TransactionType["UpdateKeyPage"] = 15] = "UpdateKeyPage";
    /** LockAccount sets a major block height that prevents tokens from being transferred out of a lite token account until that height has been reached. */
    TransactionType[TransactionType["LockAccount"] = 16] = "LockAccount";
    /** BurnCredits burns credits from a credit account. */
    TransactionType[TransactionType["BurnCredits"] = 17] = "BurnCredits";
    /** TransferCredits transfers credits between credit accounts within the same domain. */
    TransactionType[TransactionType["TransferCredits"] = 18] = "TransferCredits";
    /** UpdateAccountAuth updates authorization for an account. */
    TransactionType[TransactionType["UpdateAccountAuth"] = 21] = "UpdateAccountAuth";
    /** UpdateKey update key for existing keys. */
    TransactionType[TransactionType["UpdateKey"] = 22] = "UpdateKey";
    /** NetworkMaintenance executes network maintenance operations. */
    TransactionType[TransactionType["NetworkMaintenance"] = 46] = "NetworkMaintenance";
    /** ActivateProtocolVersion activates a new version of the protocol. */
    TransactionType[TransactionType["ActivateProtocolVersion"] = 47] = "ActivateProtocolVersion";
    /** Remote is used to sign a remote transaction. */
    TransactionType[TransactionType["Remote"] = 48] = "Remote";
    /** SyntheticCreateIdentity creates an identity. */
    TransactionType[TransactionType["SyntheticCreateIdentity"] = 49] = "SyntheticCreateIdentity";
    /** SyntheticWriteData writes data to a data account. */
    TransactionType[TransactionType["SyntheticWriteData"] = 50] = "SyntheticWriteData";
    /** SyntheticDepositTokens deposits tokens into token accounts. */
    TransactionType[TransactionType["SyntheticDepositTokens"] = 51] = "SyntheticDepositTokens";
    /** SyntheticDepositCredits deposits credits into a credit holder. */
    TransactionType[TransactionType["SyntheticDepositCredits"] = 52] = "SyntheticDepositCredits";
    /** SyntheticBurnTokens returns tokens to a token issuer's pool of issuable tokens. */
    TransactionType[TransactionType["SyntheticBurnTokens"] = 53] = "SyntheticBurnTokens";
    /** SyntheticForwardTransaction forwards a transaction from one partition to another. */
    TransactionType[TransactionType["SyntheticForwardTransaction"] = 54] = "SyntheticForwardTransaction";
    /** SystemGenesis initializes system chains. */
    TransactionType[TransactionType["SystemGenesis"] = 96] = "SystemGenesis";
    /** DirectoryAnchor anchors one network to another. */
    TransactionType[TransactionType["DirectoryAnchor"] = 97] = "DirectoryAnchor";
    /** BlockValidatorAnchor system transaction for partition data. */
    TransactionType[TransactionType["BlockValidatorAnchor"] = 98] = "BlockValidatorAnchor";
    /** SystemWriteData writes data to a system data account. */
    TransactionType[TransactionType["SystemWriteData"] = 99] = "SystemWriteData";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
/** @ignore */
(function (TransactionType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    TransactionType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "unknown":
                return TransactionType.Unknown;
            case "createidentity":
                return TransactionType.CreateIdentity;
            case "createtokenaccount":
                return TransactionType.CreateTokenAccount;
            case "sendtokens":
                return TransactionType.SendTokens;
            case "createdataaccount":
                return TransactionType.CreateDataAccount;
            case "writedata":
                return TransactionType.WriteData;
            case "writedatato":
                return TransactionType.WriteDataTo;
            case "acmefaucet":
                return TransactionType.AcmeFaucet;
            case "createtoken":
                return TransactionType.CreateToken;
            case "issuetokens":
                return TransactionType.IssueTokens;
            case "burntokens":
                return TransactionType.BurnTokens;
            case "createlitetokenaccount":
                return TransactionType.CreateLiteTokenAccount;
            case "createkeypage":
                return TransactionType.CreateKeyPage;
            case "createkeybook":
                return TransactionType.CreateKeyBook;
            case "addcredits":
                return TransactionType.AddCredits;
            case "updatekeypage":
                return TransactionType.UpdateKeyPage;
            case "lockaccount":
                return TransactionType.LockAccount;
            case "burncredits":
                return TransactionType.BurnCredits;
            case "transfercredits":
                return TransactionType.TransferCredits;
            case "updateaccountauth":
                return TransactionType.UpdateAccountAuth;
            case "updatekey":
                return TransactionType.UpdateKey;
            case "networkmaintenance":
                return TransactionType.NetworkMaintenance;
            case "activateprotocolversion":
                return TransactionType.ActivateProtocolVersion;
            case "remote":
                return TransactionType.Remote;
            case "signPending":
                return TransactionType.Remote;
            case "syntheticcreateidentity":
                return TransactionType.SyntheticCreateIdentity;
            case "syntheticwritedata":
                return TransactionType.SyntheticWriteData;
            case "syntheticdeposittokens":
                return TransactionType.SyntheticDepositTokens;
            case "syntheticdepositcredits":
                return TransactionType.SyntheticDepositCredits;
            case "syntheticburntokens":
                return TransactionType.SyntheticBurnTokens;
            case "syntheticforwardtransaction":
                return TransactionType.SyntheticForwardTransaction;
            case "systemgenesis":
                return TransactionType.SystemGenesis;
            case "directoryanchor":
                return TransactionType.DirectoryAnchor;
            case "blockvalidatoranchor":
                return TransactionType.BlockValidatorAnchor;
            case "systemwritedata":
                return TransactionType.SystemWriteData;
            default:
                throw new Error(`Unknown TransactionType '${name}'`);
        }
    }
    TransactionType.byName = byName;
    function getName(v) {
        switch (v) {
            case TransactionType.Unknown:
                return "unknown";
            case TransactionType.CreateIdentity:
                return "createIdentity";
            case TransactionType.CreateTokenAccount:
                return "createTokenAccount";
            case TransactionType.SendTokens:
                return "sendTokens";
            case TransactionType.CreateDataAccount:
                return "createDataAccount";
            case TransactionType.WriteData:
                return "writeData";
            case TransactionType.WriteDataTo:
                return "writeDataTo";
            case TransactionType.AcmeFaucet:
                return "acmeFaucet";
            case TransactionType.CreateToken:
                return "createToken";
            case TransactionType.IssueTokens:
                return "issueTokens";
            case TransactionType.BurnTokens:
                return "burnTokens";
            case TransactionType.CreateLiteTokenAccount:
                return "createLiteTokenAccount";
            case TransactionType.CreateKeyPage:
                return "createKeyPage";
            case TransactionType.CreateKeyBook:
                return "createKeyBook";
            case TransactionType.AddCredits:
                return "addCredits";
            case TransactionType.UpdateKeyPage:
                return "updateKeyPage";
            case TransactionType.LockAccount:
                return "lockAccount";
            case TransactionType.BurnCredits:
                return "burnCredits";
            case TransactionType.TransferCredits:
                return "transferCredits";
            case TransactionType.UpdateAccountAuth:
                return "updateAccountAuth";
            case TransactionType.UpdateKey:
                return "updateKey";
            case TransactionType.NetworkMaintenance:
                return "networkMaintenance";
            case TransactionType.ActivateProtocolVersion:
                return "activateProtocolVersion";
            case TransactionType.Remote:
                return "remote";
            case TransactionType.SyntheticCreateIdentity:
                return "syntheticCreateIdentity";
            case TransactionType.SyntheticWriteData:
                return "syntheticWriteData";
            case TransactionType.SyntheticDepositTokens:
                return "syntheticDepositTokens";
            case TransactionType.SyntheticDepositCredits:
                return "syntheticDepositCredits";
            case TransactionType.SyntheticBurnTokens:
                return "syntheticBurnTokens";
            case TransactionType.SyntheticForwardTransaction:
                return "syntheticForwardTransaction";
            case TransactionType.SystemGenesis:
                return "systemGenesis";
            case TransactionType.DirectoryAnchor:
                return "directoryAnchor";
            case TransactionType.BlockValidatorAnchor:
                return "blockValidatorAnchor";
            case TransactionType.SystemWriteData:
                return "systemWriteData";
            default:
                throw new Error(`Unknown TransactionType ${v}`);
        }
    }
    TransactionType.getName = getName;
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
var VoteType;
(function (VoteType) {
    /** Accept vote yea in favor of proposal. */
    VoteType[VoteType["Accept"] = 0] = "Accept";
    /** Reject vote nay against a proposal. */
    VoteType[VoteType["Reject"] = 1] = "Reject";
    /** Abstain chose not to vote on a proposal. */
    VoteType[VoteType["Abstain"] = 2] = "Abstain";
    /** Suggest put forth a proposal. */
    VoteType[VoteType["Suggest"] = 3] = "Suggest";
})(VoteType = exports.VoteType || (exports.VoteType = {}));
/** @ignore */
(function (VoteType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    VoteType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "accept":
                return VoteType.Accept;
            case "reject":
                return VoteType.Reject;
            case "abstain":
                return VoteType.Abstain;
            case "suggest":
                return VoteType.Suggest;
            default:
                throw new Error(`Unknown VoteType '${name}'`);
        }
    }
    VoteType.byName = byName;
    function getName(v) {
        switch (v) {
            case VoteType.Accept:
                return "accept";
            case VoteType.Reject:
                return "reject";
            case VoteType.Abstain:
                return "abstain";
            case VoteType.Suggest:
                return "suggest";
            default:
                throw new Error(`Unknown VoteType ${v}`);
        }
    }
    VoteType.getName = getName;
})(VoteType = exports.VoteType || (exports.VoteType = {}));
//# sourceMappingURL=enums_gen.js.map